//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AccountExtractRequest } from './models/AccountExtractRequest';
import type { BillingAddressRequest } from './models/BillingAddressRequest';
import type { ContractRelatedRequest } from './models/ContractRelatedRequest';
import { ContractTransferReason } from './models/ContractTransferReason';
import type { CopyOfContractualElementRequest } from './models/CopyOfContractualElementRequest';
import type { CustomerRequestList } from './models/CustomerRequestList';
import type { CustomerRequestStatuses } from './models/CustomerRequestStatuses';
import type { CustomerRequestsCount } from './models/CustomerRequestsCount';
import type { DenialOfContractRenewalRequest } from './models/DenialOfContractRenewalRequest';
import type { EarlyRedemptionRequest } from './models/EarlyRedemptionRequest';
import type { EquipmentRelatedRequest } from './models/EquipmentRelatedRequest';
import type { ExerciseOfPurchaseOptionRequest } from './models/ExerciseOfPurchaseOptionRequest';
import type { FileParameter } from './models/FileParameter';
import { FinancialConditionPeriodicity } from './models/FinancialConditionPeriodicity';
import { FinancialConditionType } from './models/FinancialConditionType';
import type { ReturnOfEquipmentRequest } from './models/ReturnOfEquipmentRequest';
import type { TerminationOfContractRequest } from './models/TerminationOfContractRequest';
import { TypeOfBuyback } from './models/TypeOfBuyback';
import { UploadFileType } from './models/UploadFileType';
import { Utilities } from './Utilities';
import { ValidityPeriod } from './models/ValidityPeriod';

export class CustomerRequestsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getCustomerRequests: (
			siren: string,
			contractId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}?';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (contractId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('contractId'));
            } else if (contractId !== undefined) {
                clientRequestUrl += `contractId=${encodeURIComponent(String(contractId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCustomerRequestsCount: (
			siren: string,
			contractId?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/count?';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (contractId === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('contractId'));
            } else if (contractId !== undefined) {
                clientRequestUrl += `contractId=${encodeURIComponent(String(contractId))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getCustomerRequestsStatuses: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/statuses';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentContractRelatedRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/contract-related';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentAccountExtractRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/account-extract';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentEquipmentRelatedRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/equipment-related';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitDocumentCopyOfContractualElementRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/document/copy-of-contractual-element';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractContractTransferRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/contract-transfer';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractDenialOfContractRenewalRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/denial-of-contract-renewal';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitExerciseOfPurchaseOptionRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/exercise-of-purchase-option';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractReturnOfEquipmentRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/return-of-equipment';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractEarlyRedemptionRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/early-buyback';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitEndOfContractTerminationOfContractRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/end-of-contract/termination-of-contract';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingBillingAddressRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/billing-address';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingBankDetailsRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/bank-details';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitBillingOrderNumberRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/billing/order-number';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeBankDetailsRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/bank-details';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeContractTransferRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/contract-transfer';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeHeadOfficeAddressRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/head-office-address';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitChangeFinancialConditionRequest: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/change/financial-condition';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        uploadFile: (
			siren: string,
			type?: UploadFileType,
			contractNb?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests/{siren}/upload-files?';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            if (type === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('type'));
            } else if (type !== undefined) {
                clientRequestUrl += `type=${encodeURIComponent(String(type))}&`;
            }
            if (contractNb === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('contractNb'));
            } else if (contractNb !== undefined) {
                clientRequestUrl += `contractNb=${encodeURIComponent(String(contractNb))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get All Customer Requests
     * @param contractId (optional) 
     * @return OK
     */
    async getCustomerRequests(
        siren: string,
        contractId?: string,
    ): Promise<CustomerRequestList> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequests(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CustomerRequestList>(_response, false, ['date', 'latestUpdate']);
    }

    /**
     * Get Customer Requests Count
     * @param contractId (optional) 
     * @return OK
     */
    async getCustomerRequestsCount(
        siren: string,
        contractId?: string,
    ): Promise<CustomerRequestsCount> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequestsCount(
            siren,
            contractId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CustomerRequestsCount>(_response, false, []);
    }

    /**
     * Get Customer Requests Information
     * @return OK
     */
    async getCustomerRequestsStatuses(
        siren: string,
    ): Promise<CustomerRequestStatuses> {
        const clientRequestUrl = this.baseUrl + this.routes.getCustomerRequestsStatuses(
            siren,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<CustomerRequestStatuses>(_response, false, []);
    }

    /**
     * Submit Document Contract Related Request
     * @param body (optional) 
     * @return No Content
     */
    async submitDocumentContractRelatedRequest(
        siren: string,
        body?: ContractRelatedRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentContractRelatedRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Document Account statement request
     * @param body (optional) 
     * @return No Content
     */
    async submitDocumentAccountExtractRequest(
        siren: string,
        body?: AccountExtractRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentAccountExtractRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Document Equipment Related Request
     * @param body (optional) 
     * @return No Content
     */
    async submitDocumentEquipmentRelatedRequest(
        siren: string,
        body?: EquipmentRelatedRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentEquipmentRelatedRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Document Copy Of Contractual Element Request
     * @param body (optional) 
     * @return No Content
     */
    async submitDocumentCopyOfContractualElementRequest(
        siren: string,
        body?: CopyOfContractualElementRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitDocumentCopyOfContractualElementRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract Contract Transfer Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param effectiveDate (optional) 
     * @param buyback (optional) 
     * @param toReturnMaterials (optional) 
     * @param reason (optional) 
     * @param commentary (optional) 
     * @param buyerContact_lastName (optional) 
     * @param buyerContact_firstName (optional) 
     * @param buyerContact_email (optional) 
     * @param buyerContact_phoneNumber (optional) 
     * @param buyerContact_jobTitle (optional) 
     * @param buyerAddress_sirenCode (optional) 
     * @param buyerAddress_businessName (optional) 
     * @param buyerAddress_streetNumber (optional) 
     * @param buyerAddress_streetName (optional) 
     * @param buyerAddress_additionalAddress (optional) 
     * @param buyerAddress_zipCode (optional) 
     * @param buyerAddress_city (optional) 
     * @param kbisFile (optional) 
     * @param businessTakeoverFile (optional) 
     * @param optionalCommentary (optional) 
     * @return No Content
     */
    async submitEndOfContractContractTransferRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        effectiveDate?: Date,
        buyback?: TypeOfBuyback,
        toReturnMaterials?: string[],
        reason?: ContractTransferReason,
        commentary?: string,
        buyerContact_lastName?: string,
        buyerContact_firstName?: string,
        buyerContact_email?: string,
        buyerContact_phoneNumber?: string,
        buyerContact_jobTitle?: string,
        buyerAddress_sirenCode?: string,
        buyerAddress_businessName?: string,
        buyerAddress_streetNumber?: string,
        buyerAddress_streetName?: string,
        buyerAddress_additionalAddress?: string,
        buyerAddress_zipCode?: number,
        buyerAddress_city?: string,
        kbisFile?: FileParameter,
        businessTakeoverFile?: FileParameter,
        optionalCommentary?: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractContractTransferRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (effectiveDate === null || effectiveDate === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('effectiveDate'));
        } else {
            content.append('effectiveDate', effectiveDate.toJSON());
        }
        if (buyback !== null && buyback !== undefined) {
            content.append('buyback', buyback.toString());
        }
        if (toReturnMaterials === null || toReturnMaterials === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('toReturnMaterials'));
        } else {
            toReturnMaterials.forEach((item_, index_) => {
                    content.append(`toReturnMaterials[${index_}]`, item_.toString());
                });
        }
        if (reason === null || reason === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('reason'));
        } else {
            content.append('reason', reason.toString());
        }
        if (commentary !== null && commentary !== undefined) {
            content.append('commentary', commentary.toString());
        }
        if (buyerContact_lastName === null || buyerContact_lastName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_lastName'));
        } else {
            content.append('buyerContact.lastName', buyerContact_lastName.toString());
        }
        if (buyerContact_firstName === null || buyerContact_firstName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_firstName'));
        } else {
            content.append('buyerContact.firstName', buyerContact_firstName.toString());
        }
        if (buyerContact_email === null || buyerContact_email === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_email'));
        } else {
            content.append('buyerContact.email', buyerContact_email.toString());
        }
        if (buyerContact_phoneNumber === null || buyerContact_phoneNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_phoneNumber'));
        } else {
            content.append('buyerContact.phoneNumber', buyerContact_phoneNumber.toString());
        }
        if (buyerContact_jobTitle === null || buyerContact_jobTitle === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_jobTitle'));
        } else {
            content.append('buyerContact.jobTitle', buyerContact_jobTitle.toString());
        }
        if (buyerAddress_sirenCode === null || buyerAddress_sirenCode === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_sirenCode'));
        } else {
            content.append('buyerAddress.sirenCode', buyerAddress_sirenCode.toString());
        }
        if (buyerAddress_businessName === null || buyerAddress_businessName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_businessName'));
        } else {
            content.append('buyerAddress.businessName', buyerAddress_businessName.toString());
        }
        if (buyerAddress_streetNumber === null || buyerAddress_streetNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_streetNumber'));
        } else {
            content.append('buyerAddress.streetNumber', buyerAddress_streetNumber.toString());
        }
        if (buyerAddress_streetName === null || buyerAddress_streetName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_streetName'));
        } else {
            content.append('buyerAddress.streetName', buyerAddress_streetName.toString());
        }
        if (buyerAddress_additionalAddress !== null && buyerAddress_additionalAddress !== undefined) {
            content.append('buyerAddress.additionalAddress', buyerAddress_additionalAddress.toString());
        }
        if (buyerAddress_zipCode !== null && buyerAddress_zipCode !== undefined) {
            content.append('buyerAddress.zipCode', buyerAddress_zipCode.toString());
        }
        if (buyerAddress_city === null || buyerAddress_city === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_city'));
        } else {
            content.append('buyerAddress.city', buyerAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('kbisFile'));
        } else {
            content.append('kbisFile', kbisFile.data, kbisFile.fileName ? kbisFile.fileName : 'kbisFile');
        }
        if (businessTakeoverFile !== null && businessTakeoverFile !== undefined) {
            content.append('businessTakeoverFile', businessTakeoverFile.data, businessTakeoverFile.fileName ? businessTakeoverFile.fileName : 'businessTakeoverFile');
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append('optionalCommentary', optionalCommentary.toString());
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract denial of contract renewal Request
     * @param body (optional) 
     * @return No Content
     */
    async submitEndOfContractDenialOfContractRenewalRequest(
        siren: string,
        body?: DenialOfContractRenewalRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractDenialOfContractRenewalRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract exercise of purchase option Request
     * @param body (optional) 
     * @return No Content
     */
    async submitExerciseOfPurchaseOptionRequest(
        siren: string,
        body?: ExerciseOfPurchaseOptionRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitExerciseOfPurchaseOptionRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract Return Of Equipment Request
     * @param body (optional) 
     * @return No Content
     */
    async submitEndOfContractReturnOfEquipmentRequest(
        siren: string,
        body?: ReturnOfEquipmentRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractReturnOfEquipmentRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract Early buyback Request
     * @param body (optional) 
     * @return No Content
     */
    async submitEndOfContractEarlyRedemptionRequest(
        siren: string,
        body?: EarlyRedemptionRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractEarlyRedemptionRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit EndOfContract Termination Of Contract
     * @param body (optional) 
     * @return No Content
     */
    async submitEndOfContractTerminationOfContractRequest(
        siren: string,
        body?: TerminationOfContractRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitEndOfContractTerminationOfContractRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Billing Billing address Request
     * @param body (optional) 
     * @return No Content
     */
    async submitBillingBillingAddressRequest(
        siren: string,
        body?: BillingAddressRequest,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingBillingAddressRequest(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Billing Bank details Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param bankDetails_accountHolder (optional) 
     * @param bankDetails_iban (optional) 
     * @param bankDetails_bic (optional) 
     * @param termsAcceptedProfessionalAccount (optional) Je certifie que ce compte est un compte professionnel et que notre société en est le titulaire.
     * @param termsAcceptedDebitAuthorization (optional) Je certifie que notre société autorise le prélèvement des loyers de son(ses) contrat(s) sur les nouvelles coordonnées bancaires communiquées.
     * @param termsAcceptedCompanyIsTheOnlyTenant (optional) Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer).
     * @param ribFile (optional) 
     * @return No Content
     */
    async submitBillingBankDetailsRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        optionalCommentary?: string,
        bankDetails_accountHolder?: string,
        bankDetails_iban?: string,
        bankDetails_bic?: string,
        termsAcceptedProfessionalAccount?: boolean,
        termsAcceptedDebitAuthorization?: boolean,
        termsAcceptedCompanyIsTheOnlyTenant?: boolean,
        ribFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingBankDetailsRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('optionalCommentary'));
        } else {
            content.append('optionalCommentary', optionalCommentary.toString());
        }
        if (bankDetails_accountHolder === null || bankDetails_accountHolder === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_accountHolder'));
        } else {
            content.append('bankDetails.accountHolder', bankDetails_accountHolder.toString());
        }
        if (bankDetails_iban === null || bankDetails_iban === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_iban'));
        } else {
            content.append('bankDetails.iban', bankDetails_iban.toString());
        }
        if (bankDetails_bic === null || bankDetails_bic === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_bic'));
        } else {
            content.append('bankDetails.bic', bankDetails_bic.toString());
        }
        if (termsAcceptedProfessionalAccount === null || termsAcceptedProfessionalAccount === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedProfessionalAccount'));
        } else {
            content.append('termsAcceptedProfessionalAccount', termsAcceptedProfessionalAccount.toString());
        }
        if (termsAcceptedDebitAuthorization === null || termsAcceptedDebitAuthorization === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedDebitAuthorization'));
        } else {
            content.append('termsAcceptedDebitAuthorization', termsAcceptedDebitAuthorization.toString());
        }
        if (termsAcceptedCompanyIsTheOnlyTenant === null || termsAcceptedCompanyIsTheOnlyTenant === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedCompanyIsTheOnlyTenant'));
        } else {
            content.append('termsAcceptedCompanyIsTheOnlyTenant', termsAcceptedCompanyIsTheOnlyTenant.toString());
        }
        if (ribFile === null || ribFile === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('ribFile'));
        } else {
            content.append('ribFile', ribFile.data, ribFile.fileName ? ribFile.fileName : 'ribFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Billing Order number Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param orderNumber (optional) 
     * @param validityPeriod (optional) 
     * @param orderFormFile (optional) 
     * @return No Content
     */
    async submitBillingOrderNumberRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        optionalCommentary?: string,
        orderNumber?: string,
        validityPeriod?: ValidityPeriod,
        orderFormFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitBillingOrderNumberRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('optionalCommentary'));
        } else {
            content.append('optionalCommentary', optionalCommentary.toString());
        }
        if (orderNumber === null || orderNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('orderNumber'));
        } else {
            content.append('orderNumber', orderNumber.toString());
        }
        if (validityPeriod !== null && validityPeriod !== undefined) {
            content.append('validityPeriod', validityPeriod.toString());
        }
        if (orderFormFile !== null && orderFormFile !== undefined) {
            content.append('orderFormFile', orderFormFile.data, orderFormFile.fileName ? orderFormFile.fileName : 'orderFormFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Change Bank details Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param bankDetails_accountHolder (optional) 
     * @param bankDetails_iban (optional) 
     * @param bankDetails_bic (optional) 
     * @param termsAcceptedProfessionalAccount (optional) Je certifie que ce compte est un compte professionnel et que notre société en est le titulaire.
     * @param termsAcceptedDebitAuthorization (optional) Je certifie que notre société autorise le prélèvement des loyers de son(ses) contrat(s) sur les nouvelles coordonnées bancaires communiquées.
     * @param termsAcceptedCompanyIsTheOnlyTenant (optional) Je confirme que notre société reste l’utilisatrice des matériels loués (pas de changement de locataire à déclarer).
     * @param ribFile (optional) 
     * @return No Content
     */
    async submitChangeBankDetailsRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        optionalCommentary?: string,
        bankDetails_accountHolder?: string,
        bankDetails_iban?: string,
        bankDetails_bic?: string,
        termsAcceptedProfessionalAccount?: boolean,
        termsAcceptedDebitAuthorization?: boolean,
        termsAcceptedCompanyIsTheOnlyTenant?: boolean,
        ribFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeBankDetailsRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('optionalCommentary'));
        } else {
            content.append('optionalCommentary', optionalCommentary.toString());
        }
        if (bankDetails_accountHolder === null || bankDetails_accountHolder === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_accountHolder'));
        } else {
            content.append('bankDetails.accountHolder', bankDetails_accountHolder.toString());
        }
        if (bankDetails_iban === null || bankDetails_iban === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_iban'));
        } else {
            content.append('bankDetails.iban', bankDetails_iban.toString());
        }
        if (bankDetails_bic === null || bankDetails_bic === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('bankDetails_bic'));
        } else {
            content.append('bankDetails.bic', bankDetails_bic.toString());
        }
        if (termsAcceptedProfessionalAccount === null || termsAcceptedProfessionalAccount === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedProfessionalAccount'));
        } else {
            content.append('termsAcceptedProfessionalAccount', termsAcceptedProfessionalAccount.toString());
        }
        if (termsAcceptedDebitAuthorization === null || termsAcceptedDebitAuthorization === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedDebitAuthorization'));
        } else {
            content.append('termsAcceptedDebitAuthorization', termsAcceptedDebitAuthorization.toString());
        }
        if (termsAcceptedCompanyIsTheOnlyTenant === null || termsAcceptedCompanyIsTheOnlyTenant === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('termsAcceptedCompanyIsTheOnlyTenant'));
        } else {
            content.append('termsAcceptedCompanyIsTheOnlyTenant', termsAcceptedCompanyIsTheOnlyTenant.toString());
        }
        if (ribFile === null || ribFile === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('ribFile'));
        } else {
            content.append('ribFile', ribFile.data, ribFile.fileName ? ribFile.fileName : 'ribFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Change Contract transfer Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param effectiveDate (optional) 
     * @param buyback (optional) 
     * @param toReturnMaterials (optional) 
     * @param reason (optional) 
     * @param commentary (optional) 
     * @param buyerContact_lastName (optional) 
     * @param buyerContact_firstName (optional) 
     * @param buyerContact_email (optional) 
     * @param buyerContact_phoneNumber (optional) 
     * @param buyerContact_jobTitle (optional) 
     * @param buyerAddress_sirenCode (optional) 
     * @param buyerAddress_businessName (optional) 
     * @param buyerAddress_streetNumber (optional) 
     * @param buyerAddress_streetName (optional) 
     * @param buyerAddress_additionalAddress (optional) 
     * @param buyerAddress_zipCode (optional) 
     * @param buyerAddress_city (optional) 
     * @param kbisFile (optional) 
     * @param businessTakeoverFile (optional) 
     * @param optionalCommentary (optional) 
     * @return No Content
     */
    async submitChangeContractTransferRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        effectiveDate?: Date,
        buyback?: TypeOfBuyback,
        toReturnMaterials?: string[],
        reason?: ContractTransferReason,
        commentary?: string,
        buyerContact_lastName?: string,
        buyerContact_firstName?: string,
        buyerContact_email?: string,
        buyerContact_phoneNumber?: string,
        buyerContact_jobTitle?: string,
        buyerAddress_sirenCode?: string,
        buyerAddress_businessName?: string,
        buyerAddress_streetNumber?: string,
        buyerAddress_streetName?: string,
        buyerAddress_additionalAddress?: string,
        buyerAddress_zipCode?: number,
        buyerAddress_city?: string,
        kbisFile?: FileParameter,
        businessTakeoverFile?: FileParameter,
        optionalCommentary?: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeContractTransferRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (effectiveDate === null || effectiveDate === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('effectiveDate'));
        } else {
            content.append('effectiveDate', effectiveDate.toJSON());
        }
        if (buyback !== null && buyback !== undefined) {
            content.append('buyback', buyback.toString());
        }
        if (toReturnMaterials === null || toReturnMaterials === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('toReturnMaterials'));
        } else {
            toReturnMaterials.forEach((item_, index_) => {
                    content.append(`toReturnMaterials[${index_}]`, item_.toString());
                });
        }
        if (reason === null || reason === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('reason'));
        } else {
            content.append('reason', reason.toString());
        }
        if (commentary !== null && commentary !== undefined) {
            content.append('commentary', commentary.toString());
        }
        if (buyerContact_lastName === null || buyerContact_lastName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_lastName'));
        } else {
            content.append('buyerContact.lastName', buyerContact_lastName.toString());
        }
        if (buyerContact_firstName === null || buyerContact_firstName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_firstName'));
        } else {
            content.append('buyerContact.firstName', buyerContact_firstName.toString());
        }
        if (buyerContact_email === null || buyerContact_email === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_email'));
        } else {
            content.append('buyerContact.email', buyerContact_email.toString());
        }
        if (buyerContact_phoneNumber === null || buyerContact_phoneNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_phoneNumber'));
        } else {
            content.append('buyerContact.phoneNumber', buyerContact_phoneNumber.toString());
        }
        if (buyerContact_jobTitle === null || buyerContact_jobTitle === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerContact_jobTitle'));
        } else {
            content.append('buyerContact.jobTitle', buyerContact_jobTitle.toString());
        }
        if (buyerAddress_sirenCode === null || buyerAddress_sirenCode === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_sirenCode'));
        } else {
            content.append('buyerAddress.sirenCode', buyerAddress_sirenCode.toString());
        }
        if (buyerAddress_businessName === null || buyerAddress_businessName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_businessName'));
        } else {
            content.append('buyerAddress.businessName', buyerAddress_businessName.toString());
        }
        if (buyerAddress_streetNumber === null || buyerAddress_streetNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_streetNumber'));
        } else {
            content.append('buyerAddress.streetNumber', buyerAddress_streetNumber.toString());
        }
        if (buyerAddress_streetName === null || buyerAddress_streetName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_streetName'));
        } else {
            content.append('buyerAddress.streetName', buyerAddress_streetName.toString());
        }
        if (buyerAddress_additionalAddress !== null && buyerAddress_additionalAddress !== undefined) {
            content.append('buyerAddress.additionalAddress', buyerAddress_additionalAddress.toString());
        }
        if (buyerAddress_zipCode !== null && buyerAddress_zipCode !== undefined) {
            content.append('buyerAddress.zipCode', buyerAddress_zipCode.toString());
        }
        if (buyerAddress_city === null || buyerAddress_city === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('buyerAddress_city'));
        } else {
            content.append('buyerAddress.city', buyerAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('kbisFile'));
        } else {
            content.append('kbisFile', kbisFile.data, kbisFile.fileName ? kbisFile.fileName : 'kbisFile');
        }
        if (businessTakeoverFile !== null && businessTakeoverFile !== undefined) {
            content.append('businessTakeoverFile', businessTakeoverFile.data, businessTakeoverFile.fileName ? businessTakeoverFile.fileName : 'businessTakeoverFile');
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append('optionalCommentary', optionalCommentary.toString());
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Change Head office address Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param headOfficeAddress_streetNumber (optional) 
     * @param headOfficeAddress_streetName (optional) 
     * @param headOfficeAddress_additionalAddress (optional) 
     * @param headOfficeAddress_zipCode (optional) 
     * @param headOfficeAddress_city (optional) 
     * @param kbisFile (optional) 
     * @return No Content
     */
    async submitChangeHeadOfficeAddressRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        optionalCommentary?: string,
        headOfficeAddress_streetNumber?: string,
        headOfficeAddress_streetName?: string,
        headOfficeAddress_additionalAddress?: string,
        headOfficeAddress_zipCode?: number,
        headOfficeAddress_city?: string,
        kbisFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeHeadOfficeAddressRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds === null || contractsIds === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractsIds'));
        } else {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (optionalCommentary === null || optionalCommentary === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('optionalCommentary'));
        } else {
            content.append('optionalCommentary', optionalCommentary.toString());
        }
        if (headOfficeAddress_streetNumber === null || headOfficeAddress_streetNumber === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('headOfficeAddress_streetNumber'));
        } else {
            content.append('headOfficeAddress.streetNumber', headOfficeAddress_streetNumber.toString());
        }
        if (headOfficeAddress_streetName === null || headOfficeAddress_streetName === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('headOfficeAddress_streetName'));
        } else {
            content.append('headOfficeAddress.streetName', headOfficeAddress_streetName.toString());
        }
        if (headOfficeAddress_additionalAddress !== null && headOfficeAddress_additionalAddress !== undefined) {
            content.append('headOfficeAddress.additionalAddress', headOfficeAddress_additionalAddress.toString());
        }
        if (headOfficeAddress_zipCode !== null && headOfficeAddress_zipCode !== undefined) {
            content.append('headOfficeAddress.zipCode', headOfficeAddress_zipCode.toString());
        }
        if (headOfficeAddress_city === null || headOfficeAddress_city === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('headOfficeAddress_city'));
        } else {
            content.append('headOfficeAddress.city', headOfficeAddress_city.toString());
        }
        if (kbisFile === null || kbisFile === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('kbisFile'));
        } else {
            content.append('kbisFile', kbisFile.data, kbisFile.fileName ? kbisFile.fileName : 'kbisFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit Change Financial condition Request
     * @param contractsIds (optional) 
     * @param hasDocument (optional) 
     * @param optionalCommentary (optional) 
     * @param financialConditionType (optional) 
     * @param effectiveDate (optional) 
     * @param financialConditionPeriodicity (optional) 
     * @param reason (optional) 
     * @param lastFinancialStatementFile (optional) 
     * @param lastVatStatementsFile (optional) 
     * @return No Content
     */
    async submitChangeFinancialConditionRequest(
        siren: string,
        contractsIds?: string[],
        hasDocument?: boolean,
        optionalCommentary?: string,
        financialConditionType?: FinancialConditionType,
        effectiveDate?: Date,
        financialConditionPeriodicity?: FinancialConditionPeriodicity,
        reason?: string,
        lastFinancialStatementFile?: FileParameter,
        lastVatStatementsFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitChangeFinancialConditionRequest(
            siren,
        );

        const content = new FormData();
        if (contractsIds !== null && contractsIds !== undefined) {
            contractsIds.forEach((item_, index_) => {
                    content.append(`contractsIds[${index_}]`, item_.toString());
                });
        }
        if (hasDocument === null || hasDocument === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('hasDocument'));
        } else {
            content.append('hasDocument', hasDocument.toString());
        }
        if (optionalCommentary !== null && optionalCommentary !== undefined) {
            content.append('optionalCommentary', optionalCommentary.toString());
        }
        if (financialConditionType !== null && financialConditionType !== undefined) {
            content.append('financialConditionType', financialConditionType.toString());
        }
        if (effectiveDate !== null && effectiveDate !== undefined) {
            content.append('effectiveDate', effectiveDate.toJSON());
        }
        if (financialConditionPeriodicity !== null && financialConditionPeriodicity !== undefined) {
            content.append('financialConditionPeriodicity', financialConditionPeriodicity.toString());
        }
        if (reason !== null && reason !== undefined) {
            content.append('reason', reason.toString());
        }
        if (lastFinancialStatementFile !== null && lastFinancialStatementFile !== undefined) {
            content.append('lastFinancialStatementFile', lastFinancialStatementFile.data, lastFinancialStatementFile.fileName ? lastFinancialStatementFile.fileName : 'lastFinancialStatementFile');
        }
        if (lastVatStatementsFile !== null && lastVatStatementsFile !== undefined) {
            content.append('lastVatStatementsFile', lastVatStatementsFile.data, lastVatStatementsFile.fileName ? lastVatStatementsFile.fileName : 'lastVatStatementsFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit client request file
     * @param type (optional) 
     * @param contractNb (optional) 
     * @param fileToUpload (optional) 
     * @return No Content
     */
    async uploadFile(
        siren: string,
        type?: UploadFileType,
        contractNb?: string,
        fileToUpload?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.uploadFile(
            siren,
            type,
            contractNb,
        );

        const content = new FormData();
        if (fileToUpload === null || fileToUpload === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('fileToUpload'));
        } else {
            content.append('fileToUpload', fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : 'fileToUpload');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
